/* eslint-disable */
import type { Money } from "../../../common/currency.pb";
import type { Image } from "../../ui/Image.pb";

export enum ProductStatus {
  /** UNKNOWN_PRODUCT_STATUS - set a default value */
  UNKNOWN_PRODUCT_STATUS = "UNKNOWN_PRODUCT_STATUS",
  PRODUCT_ACTIVE = "PRODUCT_ACTIVE",
  PRODUCT_INACTIVE = "PRODUCT_INACTIVE",
}

export enum ProductAvailability {
  /** UNKNOWN_PRODUCT_AVAILABILITY_STATUS - set a default value */
  UNKNOWN_PRODUCT_AVAILABILITY_STATUS = "UNKNOWN_PRODUCT_AVAILABILITY_STATUS",
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK",
}

export enum ProductFeed {
  /** UNKNOWN_PRODUCT_FEED - set a default value */
  UNKNOWN_PRODUCT_FEED = "UNKNOWN_PRODUCT_FEED",
  CASH_APP = "CASH_APP",
  AFTERPAY = "AFTERPAY",
}

export interface Product {
  token?: string;
  name?: string;
  description?: string;
  vendor?: string;
  /** @deprecated */
  feed?: ProductFeed;
  feeds?: ProductFeed[];
  business_info?: ProductBusinessInfo;
  business_token?: string;
  afterpay_store_id?: string;
  /** For organic products, the same product maps to AP and Cash business profiles */
  business_tokens?: string[];
  status?: ProductStatus;
  version?: number;
  tags?: string[];
}

export interface ProductBusinessInfo {
  name?: string;
  logo?: Image;
}

export interface ProductVariant {
  product_token?: string;
  variant_id?: string;
  price?: Money;
  original_price?: Money;
  version?: number;
  availability?: ProductAvailability;
  url?: string;
  main_image?: Image;
}
